import React from 'react'

import Section from '../../../shared/settings/section'
import Purchasing from './purchasing'
import { TESTERS } from '../../../../lib/tester-classnames'

function ProfileSecurity() {
  return (
    <Section title="Purchasing Security" testerClassName={TESTERS.ACCOUNT.PURCHASING_SECURITY}>
      <Purchasing />
    </Section>
  )
}

export default ProfileSecurity
